import React from 'react';
import './cn-demo-block.scss';
const CnDemoBlock = (props) => {
    const { padding = '12px 12px' } = props;
    return (React.createElement("div", { className: "cn-ui-m-demo-block" },
        React.createElement("div", { className: "title" }, props.title),
        React.createElement("div", { className: "main", style: {
                padding,
            } }, props.children)));
};
export default CnDemoBlock;
